import type { HoleRange } from '@/lib/db/types';

export type RoundLength = 9 | 18 | 27;

interface Props {
  length: RoundLength;
  nineSide: 'front-9' | 'back-9';
  onLengthChange: (length: RoundLength) => void;
  onNineSideChange: (side: 'front-9' | 'back-9') => void;
}

export function holeRangeFromLength(length: RoundLength, nineSide: 'front-9' | 'back-9'): HoleRange {
  if (length === 18) return 'full';
  if (length === 9) return nineSide;
  return 'full';
}

export function RoundLengthPicker({ length, nineSide, onLengthChange, onNineSideChange }: Props) {
  const options: { id: RoundLength; label: string; disabled?: boolean }[] = [
    { id: 9, label: '9' },
    { id: 18, label: '18' },
    { id: 27, label: '27', disabled: true },
  ];

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        {options.map((opt) => (
          <button
            key={opt.id}
            type="button"
            disabled={opt.disabled}
            onClick={() => !opt.disabled && onLengthChange(opt.id)}
            className={`relative flex-1 rounded-lg py-2.5 text-sm font-bold ${
              length === opt.id
                ? 'bg-navy text-cream'
                : opt.disabled
                  ? 'cursor-not-allowed border border-line bg-cream-warm text-mute'
                  : 'border border-line bg-paper text-ink-soft'
            }`}
          >
            {opt.label}
            {opt.disabled && (
              <span className="absolute -bottom-2 left-1/2 -translate-x-1/2 whitespace-nowrap text-[8px] font-semibold uppercase tracking-wide text-mute">
                Soon
              </span>
            )}
          </button>
        ))}
      </div>
      {length === 9 && (
        <div className="flex gap-2">
          {([
            ['front-9', 'Front 9'],
            ['back-9', 'Back 9'],
          ] as const).map(([id, label]) => (
            <button
              key={id}
              type="button"
              onClick={() => onNineSideChange(id)}
              className={`flex-1 rounded-lg py-2 text-xs font-semibold ${
                nineSide === id ? 'bg-gold text-navy' : 'border border-line bg-paper text-ink-soft'
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
